import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { ROUTES } from './routes';

/**
 * ProtectedRoute — mirrors Flutter routing_config.dart auth guard logic.
 *
 * Decision tree (matches Flutter routing_config.dart):
 *   1. Not logged in → /login (preserves intended destination via state.from)
 *   2. Otherwise → render children
 *
 * Maintenance mode is handled for every route in AppRouter, and unverified email and
 * pending MFA for every route by AccountGuard.
 *
 * AuthProvider renders the router only after Firebase has restored the session,
 * so `user` is final here and there is no premature redirect to /login.
 */
export function ProtectedRoute() {
  const { user } = useAuthStore();
  const location = useLocation();

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
